
import "@/styles/pages/apowerMirror/index.css";
          // window.installFramework = window.installFramework || Function.prototype
          installFramework(function(Vue) {
            // 入口文件

new Vue({
  created($, apower, LazyLoad) {
    // compute downloads
    var $downloadsCount = $(".js-downloads-count");
    function getDownloadCount() {
      var time = Math.round(Date.now() / 2000 - 764968547);
      var count = Math.ceil(Math.random() * 3) - 2 + time;
      count = count
        .toString()
        .split("")
        .reverse()
        .join("")
        .replace(/(\d{3})/g, "$1,")
        .split("")
        .reverse()
        .join("");
      $downloadsCount.text(count);

      window.setTimeout(
        getDownloadCount,
        Math.ceil(Math.random() * 5000) + 5000
      );
    }
    getDownloadCount();

    //for toggle main shadow
    $.registerOnce(".main-bg >div", function () {
      this.el.$on("mouseenter", function (e) {
        var div = $(e.target).closest("div");

        div.siblings("div").removeClass("active");
        div.addClass("active");
      });
    });

    $.registerOnce(".video-guide > div", {
      init: function () {
        if (this.el.dir("tip")) {
          this.el.dir("tip").on("show", this.onShow, this);
          this.el.dir("tip").on("hide", this.onHide, this);
        }
      },

      onShow: function (layer) {
        layer.addClass("active");
      },

      onHide: function (layer) {
        layer.removeClass("active");
      },
    });

    $.registerOnce(".situation li", {
      init: function () {
        if ($(window).width() > 768) {
          this.el.$on("mouseenter", this.triggerActive, this);
        } else {
          this.el.$on("click", this.triggerActive, this);
        }
      },

      triggerActive: function (e) {
        var li = $(e.target).closest("li");

        li.siblings("li").removeClass("active");
        li.addClass("active");
      },
    });

    //for support-table
    $.registerOnce(".support-table .wrapper", {
      init: function () {
        var parameter = this.el.find(".parameter-content");
        var category = this.el.find(".category-content");

        this.syncHeight(parameter, category);
        $(window).$on(
          "resize",
          this.syncHeight.bind(this, parameter, category)
        );
      },

      syncHeight: function (parameter, category) {
        var isParameterActive = parameter.is(".active");
        if (!isParameterActive) {
          parameter.addClass("active");
        }

        parameter.css("min-height", "0");
        var paraHeight = parameter[0].offsetHeight;

        if (!isParameterActive) {
          parameter.removeClass("active");
        }

        this.el.find("> div").css("min-height", paraHeight);
      },
    });

    //text too lone for white-space norwrap
    $.registerOnce(
      ".mirror-android, .reflect-iphone, .control-pc, .big-screen",
      {
        init: function () {
          $.onWinLoaded(this.onWinLoaded, this);
        },

        onWinLoaded: function () {
          $.newCom("font-fit", this.el);
          this.el.addClass("active");
        },
      }
    );

    $.register("survey-poste-win", {
      selector: ".survey-poster",

      autoDestroy: true,

      expiredAfter: 1 * 60 * 60 * 1000, //1 hour

      init() {
        if (!$.store.get("activity_closed")) {
          this.el.css("display", "flex");
        } else {
          this.el.css("display", "none");
        }

        this.el.find(".close").$on("click", this.onClickClose, this);
      },

      onClickClose() {
        this.el.css("display", "none");
        $.store.set("activity_closed", true, this.expiredAfter);
      },
    });

    // 点击切换评论
    var commentIndex = 1;
    $(".change-btn").click(function () {
      commentIndex = commentIndex < 3 ? commentIndex + 1 : 1;
      $(".comment-item:nth-child(" + commentIndex + ")")
        .siblings(".comment-item")
        .css("display", "none");
      $(".comment-item:nth-child(" + commentIndex + ")").css(
        "display",
        "block"
      );
    });

    // 页面滚动增加对应的动态效果class
    if (
      apower.lang === "en" ||
      apower.lang === "fr" ||
      apower.lang === "es" ||
      apower.lang === "pt" ||
      apower.lang === "de"
    ) {
      $(".right-options").css("display", "flex");
    }
    $(window).scroll(function () {
      let bHeight = document.body.clientHeight;
      let toTop = $(document).scrollTop();
      if (!/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        // pc 端才显示右侧分享栏
        if (
          apower.lang === "en" ||
          apower.lang === "fr" ||
          apower.lang === "es" ||
          apower.lang === "pt" ||
          apower.lang === "de"
        ) {
          if (toTop < 700) {
            $(".right-options").css("display", "flex");
          } else {
            $(".right-options").css("display", "none");
          }
        } else {
          if (toTop > 700) {
            $(".right-options").css("display", "flex");
          } else {
            $(".right-options").css("display", "none");
          }
        }
      }
      if ($(".features").length > 0) {
        if (
          toTop > $(".features").offset().top - bHeight &&
          toTop < $(".features").offset().top + $(".features").height()
        ) {
          $(".features .featbox .item img").addClass("inview");
        } else {
          $(".features .featbox .item img").removeClass("inview");
        }
      }
      if ($(".cast-screen").length > 0) {
        if (
          toTop > $(".cast-screen").offset().top - bHeight &&
          toTop < $(".cast-screen").offset().top + $(".cast-screen").height()
        ) {
          $("#cast-pc").trigger("play");
          $("#cast-phone").trigger("play");
        } else {
          $("#cast-pc").trigger("pause");
          $("#cast-phone").trigger("pause");
        }
      }
      if ($(".control").length > 0) {
        if (
          toTop > $(".control").offset().top - bHeight &&
          toTop < $(".control").offset().top + $(".control").height()
        ) {
          $("#control-pc").trigger("play");
          $("#control-phone").trigger("play");
        } else {
          $("#control-pc").trigger("pause");
          $("#control-phone").trigger("pause");
        }
      }
    });

    // 复写分享组件  为了mirror的页面显示知乎 start
    $.extend($.getComponent("fixed-share").prototype, {
      template: function () {
        var shareLinks = $.getDirective("bind-share").prototype.links;
        var hasWeixin =
          this.hasWeixin && shareLinks.weixin && shareLinks.weixin.img;

        if (apower.lang === "zh") {
          return (
            '<div class="counted-share-vertical" data-share>' +
            "<ul>" +
            // (hasWeixin ? '<li class="share-vertical-weixin"><div></div></li>' : '') +
            '<li class="share-vertical-zhihu"><div></div></li>' +
            '<li class="share-vertical-bilibili"><div></div></li>' +
            '<li class="share-vertical-weibo"><div></div></li>' +
            '<li class="share-vertical-tieba"><div></div></li>' +
            '<li class="share-vertical-tencent"><div></div></li>' +
            "</ul>" +
            '<div class="share-vertical-hidebar"></div>' +
            "</div>"
          );
        } else {
          var shareClass = apower.lang === "ja" ? "hatena" : "pinterest";

          // 日语站的linkedin显示新图标
          var linkedInClass = apower.lang === "ja" ? "linkedinja" : "linkedin";

          // 根据运营同事要求，日语站的排列顺序
          if (apower.lang === "ja") {
            return (
              '<div class="counted-share-vertical" data-share>' +
              "<ul>" +
              '<li class="share-vertical-google"><div>-</div></li>' +
              '<li class="share-vertical-twitter"><div>{@@share}</div></li>' +
              '<li class="share-vertical-' +
              linkedInClass +
              '"><div></div></li>' +
              '<li class="share-vertical-facebook"><div>-</div></li>' +
              '<li class="share-vertical-' +
              shareClass +
              '"><div>-</div></li>' +
              "</ul>" +
              '<div class="share-vertical-hidebar"></div>' +
              "</div>"
            );
          } else {
            return (
              '<div class="counted-share-vertical" data-share>' +
              "<ul>" +
              // '<li class="share-vertical-google"><div>-</div></li>' +
              '<li class="share-vertical-facebook"><div>-</div></li>' +
              '<li class="share-vertical-twitter"><div>{@@share}</div></li>' +
              '<li class="share-vertical-' +
              shareClass +
              '"><div>-</div></li>' +
              '<li class="share-vertical-' +
              linkedInClass +
              '"><div></div></li>' +
              "</ul>" +
              '<div class="share-vertical-hidebar"></div>' +
              "</div>"
            );
          }
        }
      },
    });

    $.extend($.getDirective("bind-share").prototype, {
      links: {
        google: {
          url: "https://plus.google.com/share?url={url}&t={title}",
          width: 500,
          height: 500,
        },

        facebook: {
          url: "http://www.facebook.com/sharer/sharer.php?u={url}&title={title}",
          width: 673,
          height: 374,
        },

        twitter: {
          url: "https://twitter.com/intent/tweet?url={url}&text={title}",
          width: 548,
          height: 430,
        },

        pinterest: {
          url: "//assets.pinterest.com/js/pinmarklet.js",
          append: true,
          width: 600,
          height: 400,
        },

        hatena: {
          url: "http://b.hatena.ne.jp/entry/panel/?url={url}&btitle={title}",
          width: 365,
          height: 220,
        },

        weixin: {
          img: "/do.php?action=qrcode&data={url}&size=5",
        },

        douban: {
          url: "http://www.douban.com/share/service?href={url}&name={title}&text={text}",
        },

        qzone: {
          url: "http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url={url}&title={title}&desc={text}&summary=&site=",
        },

        weibo: {
          url: "http://service.weibo.com/share/share.php?url={url}&title={title}&searchPic=true",
        },

        tencent: {
          url: "http://share.v.t.qq.com/index.php?c=share&a=index&url={url}&title={title}",
        },

        youdao: {
          url: "http://note.youdao.com/memory/?url={url}&title={title}",
        },

        linkedinja: {
          img: "https://qncdncss.aoscdn.com/img/phone-mirror/linkedin-jp.png",
        },
        linkedin: {
          url: "https://www.linkedin.com/shareArticle?mini=true&url={url}&title={title}",
          width: 600,
          height: 600,
        },

        zhihu: {
          url: "https://www.zhihu.com/org/ao-ruan-tou-ping",
        },
      },

      getShareLink: function (name, url, title, text) {
        var link = this.links[name].url || this.links[name].img;

        if (name === "weixin") {
          if (link.indexOf("http") !== 0) {
            link = apower.getDomain("zh") + link;
          }
        }
        if (name === "linkedinja") {
          if (link.indexOf("http") !== 0) {
            link = apower.getDomain("ja") + link;
          }
        }

        var o = {
          url: encodeURIComponent(url),
          title: encodeURIComponent(title),
          text: encodeURIComponent(text),
        };

        link = link.format(o);

        return link;
      },
    });

    // 复写分享组件  为了mirror的页面显示知乎 end
  },
});

          })
        